export class CreateDeliveryOrderRequestData {
  constructor() {
    this.clientOrderId = null;
    this.packages = null;
  }
}
